import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { DEBUG_LANGUAGE, PRIVILEGES, DATE_PICKER_LOCALES } from "@/utils/const";
import { updateDateLocale } from "@/utils/util";
import { loadLanguageAsync } from "@/plugins/i18n";
import network from "@/utils/network";
import Menu from "primevue/menu";
import Button from "primevue/button";
import { usePrimeVue } from "primevue/config";
export default {
  name: "LanguageSelector",
  // eslint-disable-next-line vue/no-reserved-component-names
  components: {
    Button,
    Menu
  },
  data() {
    return {
      primevue: usePrimeVue()
    };
  },
  computed: {
    languages() {
      const baseLanguages = [{
        value: "hu",
        label: this.$tf("profile.language.hu|Magyar")
      }, {
        value: "en",
        label: this.$tf("profile.language.en|Angol")
      }];
      const extLanguages = [];
      if (this.$store.getters["session/hasAuthority"](PRIVILEGES.MISC.BETA.BETA)) {
        extLanguages.push({
          value: DEBUG_LANGUAGE,
          label: this.$tf(`${DEBUG_LANGUAGE}|${DEBUG_LANGUAGE}`)
        });
      }
      return baseLanguages.concat(extLanguages);
    },
    selectedLangOption() {
      const saved = this.$i18n.locale;
      return this.languages.find(o => o.value === saved);
    }
  },
  methods: {
    async changeLanguage(newLang) {
      updateDateLocale(newLang);
      await loadLanguageAsync(newLang);
      const axios = await network.connection();
      try {
        await axios.patch(`census/lang/mine/${newLang}`);
        this.primevue.config.locale.dayNames = DATE_PICKER_LOCALES[newLang].dayNames;
        this.primevue.config.locale.dayNamesShort = DATE_PICKER_LOCALES[newLang].dayNamesShort;
        this.primevue.config.locale.dayNamesMin = DATE_PICKER_LOCALES[newLang].dayNamesMin;
        this.primevue.config.locale.monthNames = DATE_PICKER_LOCALES[newLang].monthNames;
        this.primevue.config.locale.monthNamesShort = DATE_PICKER_LOCALES[newLang].monthNamesShort;
      } catch (ex) {
        console.log("Failed changing language");
      }
    },
    toggleMenu(event) {
      this.$refs.menu.toggle(event);
    }
  },
  mounted() {
    this.changeLanguage(this.$i18n.locale);
  }
};